import { Component } from '@angular/core';
import { PlanComponent } from '../plan/plan.component';

@Component({
  selector: 'app-upgrade-pricing',
  standalone: true,
  imports: [PlanComponent],
  templateUrl: './upgrade-pricing.component.html',
  styleUrl: './upgrade-pricing.component.scss'
})
export class UpgradePricingComponent {

}
